import { isNil as _isNil } from 'lodash';
import React, { HTMLAttributes } from 'react';
import styled from 'styled-components';

export const StyledIcon = styled.svg`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
    fill: currentColor;
`;

export const StyledIconWrapper = styled.i`
    position: relative;
    width: 1em;
    display: inline-block;
    line-height: 1;
    text-transform: none;
    letter-spacing: normal;
    word-wrap: normal;
    white-space: nowrap;
    direction: ltr;

    &:before {
        position: relative;
        content: '';
        display: block;
        padding-top: 100%;
    }
`;

type Props = HTMLAttributes<HTMLElement> & {
    onClick?: () => void;
};

const Icon = (props: Props) => {
    const onClick = () => {
        if (!_isNil(props.onClick)) {
            props.onClick();
        }
    };

    return (
        <StyledIconWrapper onClick={onClick} className={props.className}>
            <StyledIcon viewBox="0 0 1024 1024">
                <path d="M824.202 132.792c-22.618-20.548-120.243-81.889-323.94-82.778 0 0-241.211-15.847-358.304 90.209-65.168 64.346-87.124 160.033-89.532 276.802s-14.877 339.838 198.707 399.177c-0.345 61.417-0.84 165.606-0.938 180.161 0 10.179 1.616 17.141 7.431 18.579 4.183 1.018 10.452-1.147 15.782-6.462 34.153-34.297 143.49-166.204 143.49-166.204 146.704 9.581 263.424-19.386 275.977-23.489 29.595-9.517 189.678-23.262 216.767-242.1 27.998-225.572-10.289-379.545-85.443-443.892zM525.141 589.834c0 0 19.144 1.616 29.451-11.084l20.097-25.283c9.694-12.537 33.086-20.533 55.992-7.771 17.165 9.79 33.831 20.433 49.935 31.889 15.203 11.179 46.331 37.155 46.43 37.155 14.831 12.519 18.254 30.905 8.158 50.291 0 0.113-0.080 0.307-0.080 0.405-11.121 19.277-25.239 36.663-41.826 51.502-0.193 0.098-0.193 0.193-0.371 0.291-14.411 12.039-28.567 18.886-42.47 20.533-2.047 0.359-4.127 0.488-6.204 0.386-6.132 0.060-12.232-0.88-18.061-2.779l-0.451-0.662c-21.422-6.042-57.188-21.165-116.753-54.023-34.469-18.791-67.283-40.468-98.094-64.797-15.443-12.188-30.174-25.251-44.12-39.127l-4.459-4.459c-0.5-0.485-0.984-0.984-1.487-1.487-13.876-13.947-26.94-28.677-39.127-44.12-24.327-30.805-46.003-63.616-64.797-98.076-32.859-59.58-47.981-95.316-54.023-116.769l-0.662-0.451c-1.892-5.832-2.828-11.932-2.763-18.061-0.113-2.075 0.011-4.157 0.371-6.204 1.734-13.882 8.589-28.051 20.567-42.504 0.098-0.178 0.193-0.178 0.291-0.371 14.836-16.587 32.222-30.698 51.502-41.808 0.098 0 0.291-0.098 0.405-0.098 19.386-10.096 37.772-6.674 50.275 8.078 0.098 0.098 26.026 31.227 37.155 46.43 11.458 16.118 22.102 32.8 31.889 49.984 12.761 22.891 4.766 46.331-7.771 55.992l-25.283 20.097c-12.761 10.308-11.084 29.451-11.084 29.451s37.447 141.727 177.367 177.447zM745.236 472.419c-7.431-0.008-13.559-6.091-13.62-13.522-0.629-83.248-24.606-146.833-73.295-194.361-48.11-46.85-108.884-70.888-180.661-71.406-7.451-0.025-13.571-6.166-13.571-13.62 0-7.472 6.148-13.62 13.62-13.62 0.015 0 0.034 0 0.049 0h0.113c79.031 0.583 146.137 27.206 199.467 79.159s80.825 123.973 81.533 213.682c0.054 7.466-6.040 13.654-13.507 13.715l-0.129-0.034zM673.719 444.473h-0.322c-7.466-0.175-13.465-6.46-13.295-13.927 1.049-46.543-12.246-84.232-40.645-115.217s-67.091-47.785-118.676-51.567c-7.088-0.52-12.643-6.496-12.643-13.602 0-7.482 6.157-13.638 13.638-13.638 0.33 0 0.662 0.011 0.992 0.037 58.044 4.248 104.053 24.557 136.768 60.338s48.981 81.049 47.785 134.216c-0.147 7.364-6.237 13.344-13.602 13.359zM603.831 421.048c-7.206 0-13.226-5.727-13.586-12.924-2.309-46.221-24.087-68.852-68.53-71.244-7.043-0.56-12.54-6.513-12.54-13.576 0-7.472 6.149-13.62 13.62-13.62 0.13 0 0.259 0.002 0.39 0.005 58.642 3.232 91.243 36.72 94.248 97.076 0.011 0.227 0.015 0.451 0.015 0.678 0 7.218-5.734 13.243-12.939 13.602h-0.678z" />
            </StyledIcon>
        </StyledIconWrapper>
    );
};

export default Icon;
